import React from 'react';
import {Spin} from 'antd'

const Loader = () => {
    return (
        <div>
            <Spin/>
        </div>
    )
}

export default Loader
